<div id="photo_gallery_mozaic" class="ion-content-scroll-host">
    @for(photo of this.photosItemsDisplayed; track $index){
        <app-photo-gallery-item [photo]="photo" [size]="this.sizePhoto" (onSelectPhoto)="this.selectPhoto($event)"/>
    }
    <ion-infinite-scroll (ionInfinite)="this.onIonInfinite($event)" [disabled]="this.disabledInfiniteScroll">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
    </ion-infinite-scroll>
</div>